import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { benefitTemplatesFetch } from './action';
import { selectFeatureBenefitTemplate } from './selector';

export const useBenefitTemplatesFetch = () => {
  const dispatch = useDispatch();
  const { benefitTemplates } = useSelector(selectFeatureBenefitTemplate);

  useEffectOnce(() => {
    if (!isEmpty(benefitTemplates)) return;
    dispatch(benefitTemplatesFetch());
  });

  return benefitTemplates;
};
